export function toTitleCase(str: string) {
  return str.replace(/[_-]/g, " ").replace(/\w\S*/g, (txt: string) => {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
}
